import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { SharedService } from "src/app/services/shared.service";
import { environment } from "src/environments/environment";
import { AlertService } from 'src/app/services/alert.service';
import { timer } from "rxjs";

@Component({
  selector: "app-prediction-detail",
  templateUrl: "./prediction-detail.component.html",
  styleUrls: ["./prediction-detail.component.scss"],
})
export class PredictionDetailComponent implements OnInit {
  playVideo: any = {
    play: false,
    id: "",
    showControl: true,
  };
  isApp = environment.app;
  preditionDate: any;
  constructor(
    private dialogRef: MatDialogRef<PredictionDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sharedService: SharedService,
    private alertService:AlertService
  ) {
    this.alertService.getIsMobileDevice().subscribe((res: boolean) => {
      if (!environment.app) {
        this.isApp = res;
      }
    })
  }

  ngOnInit() {
    this.getPredictionDate();
  }

  playVideoNow(id, eleId: HTMLMediaElement) {
    if (this.playVideo.id !== id) {
      this.playVideo.play = true;
      timer(100).subscribe(() => {
        this.playVideo.id = id;
        eleId.play();
      });
    }
  }

  videoHover() {
    this.playVideo.showControl = true;
  }

  videoHoverOut() {
    this.playVideo.showControl = false;
  }

  playerClick(id, eleID: HTMLMediaElement) {
    if ((this.playVideo, id === id)) {
      if (this.playVideo.play) {
        this.playVideo.play = false;
        eleID.pause();
      } else {
        this.playVideo.play = true;
        eleID.play();
      }
    }
  }

  calculateNiftyPrediction(nifty) {
    let profitLoss = 0;
    let isProfit: boolean = false;
    let percent = 0;
    if (nifty) {
      if (nifty.niftyClosedPrice > nifty.niftyPrice) {
        isProfit = false;
        profitLoss = nifty.niftyClosedPrice - nifty.niftyPrice;
      } else {
        isProfit = true;
        profitLoss = nifty.niftyPrice - nifty.niftyClosedPrice;
      }
      percent = (profitLoss / nifty.niftyClosedPrice) * 100;
    }

    return {
      profitLoss: profitLoss,
      isProfit: isProfit,
      percent: percent,
    };
  }

  getPredictionDate() {
    this.sharedService.predictionDate().subscribe((res) => {
      this.preditionDate = res.data.date;
    });
  }

  close(){
    this.dialogRef.close()
  }
}
